import { createSlice } from '@reduxjs/toolkit';
import set from 'lodash.set';
import { storeData, retrieveData } from '../commons/localStorage';
import reduxConstants from './reduxConstants';

// const { storeData, retrieveData } = localStorage;
const initialState = retrieveData(reduxConstants.STORE_NAME) || {
  [reduxConstants.config.LOGIN]: {},
  [reduxConstants.config.APP_STATE]: {},
  [reduxConstants.config.APP_SCHEMA]: {},
  [reduxConstants.config.NOTIFICATIONS]: { refreshTrigger: null }, // Add this
  [reduxConstants.config.REFETCHDATA]: {
    key: '',
    shouldRefetch: false,
    currentRelatedScreenID: null,
    isActionForMainTable: true,
  },
};

export const configSlice = createSlice({
  name: reduxConstants.STORE_NAME,
  initialState,
  reducers: {
    [reduxConstants.actions.CREATE]: (state, actions) => {
      // Redux Toolkit allows us to write "mutating" logic in reducers. It
      // doesn't actually mutate the state because it uses the Immer library,
      // which detects changes to a "draft state" and produces a brand new
      // immutable state based off those changes
      set(state, actions.payload.setPath, actions.payload.value);
      storeData(reduxConstants.STORE_NAME, state);
    },
    [reduxConstants.actions.UPDATE]: (state) => {
      // eslint-disable-next-line no-param-reassign
      state.value = 1;
    },
    // Add the notification refresh reducer
    [reduxConstants.actions.TRIGGER_NOTIFICATION_REFRESH]: (state, action) => {
      state[reduxConstants.config.NOTIFICATIONS].refreshTrigger = action.payload;
      storeData(reduxConstants.STORE_NAME, state);
    },
    [reduxConstants.actions.TRIGGER_REFETCH]: (state, action) => {
      const { key, shouldRefetch, currentRelatedScreenID, isActionForMainTable } = action.payload;
      state[reduxConstants.config.REFETCHDATA] = {
        key,
        shouldRefetch,
        currentRelatedScreenID,
        isActionForMainTable,
      };
      storeData(reduxConstants.STORE_NAME, state);
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  create,
  update,
  [reduxConstants.actions.TRIGGER_NOTIFICATION_REFRESH]: triggerNotificationRefresh,
  [reduxConstants.actions.TRIGGER_REFETCH]: triggerRefetch,
} = configSlice.actions;

export default configSlice.reducer;
